/*eslint-disable*/
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import Lottie from "react-lottie";
import LottieNotFound from "../animations/lottie_not_found.json";

const useStyles = makeStyles((theme) => ({
  gridMain: {
    width: "80%",
    top: "30%",
    position: "absolute",
  },
}));

export default function NotRecordsFound(props) {
  const classes = useStyles();
  const { title, subtitle } = props;

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LottieNotFound,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      className={classes.gridMain}
    >
      <Grid container direction="column" alignItems="center">
        <Lottie options={defaultOptions} height={300} width={300} />
        <Typography
          style={{
            fontFamily: "Roboto",
            fontSize: 26,
            fontWeight: 500,
            color: "#fff",
          }}
        >
          {title}
        </Typography>
        <Typography
          style={{
            fontFamily: "Roboto",
            fontSize: 18,
            color: "#acacac",
          }}
        >
          {subtitle}
        </Typography>
      </Grid>
    </Grid>
  );
}
